<template>
    <div class="annual-meeting-page">
        <div class="top-banner">
            <img :src="require('../../assets/images/2026/banner_top.jpg')" alt="年会banner" class="banner-img">
        </div>
        <div class="intro-section" :style="{ backgroundImage: `url(${require('../../assets/images/2026/intro_bg.jpg')})`, backgroundRepeat: 'no-repeat', backgroundSize: '100% 100%' }">
            <div class="intro-content">
                <div class="intro-panel">
                    <div class="intro-left">
                        <img :src="require('../../assets/images/2026/img_interview.png')" alt="高端访谈" class="intro-img">
                    </div>
                    <div class="intro-right">
                        <div class="intro-title-row">
                            <span class="intro-year">2026</span>
                            <span class="intro-divider">|</span>
                            <div class="intro-title-wrapper">
                                <span class="intro-title">钢铁产业发展春季论坛</span>
                                <span class="intro-title">暨 2025中国钢铁产业网年会</span>
                            </div>
                        </div>
                        <div class="intro-text">
                            2026年3月25日-26日，钢铁产业发展春季论坛暨2025中国钢铁产业网年会在唐山召开。粗钢产量达峰后，行业经历五年下行期。"十五五"迎来新格局新机遇，会议聚焦新开局、新动能、新机遇，唐宋大数据发布"AI大脑"智能经营解决方案，覆盖预测、策略、套保、基差、库存、交易等场景，实现从分析到交易、管理到价值挖掘的智能化，助力企业从经验转向智能决策。河钢供应链与唐宋签约合作，智能预测、套保系统已在宝钢、河钢等企业应用。
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="speech-section">
            <div class="speech-content">
                <div class="speech-title">
                    <img :src="require('../../assets/images/2026/title_speech.png')" alt="会议致辞" class="speech-title-img">
                </div>
                <div class="speech-cards">
                    <div class="speech-card">
                        <div class="speech-card-img-wrapper">
                            <img :src="require('../../assets/images/2026/avatar_ye.png')" alt="叶会华" class="speech-photo">
                            <span class="speech-name">叶会华</span>
                            <div class="speech-card-info">
                                <p>杭州杭钢对外经济贸易有限公司</p>
                                <p>董事长</p>
                            </div>
                        </div>
                    </div>
                    <div class="speech-card">
                        <div class="speech-card-img-wrapper">
                            <img :src="require('../../assets/images/2026/avatar_yan.png')" alt="闫义军" class="speech-photo">
                            <span class="speech-name">闫义军</span>
                            <div class="speech-card-info">
                                <p>山东冠洲股份有限公司</p>
                                <p>销售总经理</p>
                            </div>
                        </div>
                    </div>
                    <div class="speech-card">
                        <div class="speech-card-img-wrapper">
                            <img :src="require('../../assets/images/2026/avatar_bai.png')" alt="白章社" class="speech-photo">
                            <span class="speech-name">白章社</span>
                            <div class="speech-card-info">
                                <p>正大制管集团</p>
                                <p>经营副总裁</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="speech-section">
            <div class="speech-content">
                <div class="speech-title">
                    <img :src="require('../../assets/images/2026/title_lecture.png')" alt="会议演讲" class="speech-title-img">
                </div>
                <div class="speech-cards">
                    <div class="speech-card">
                        <div class="speech-card-img-wrapper">
                            <img :src="require('../../assets/images/2026/avatar_li_yj.png')" alt="李拥军" class="speech-photo">
                            <span class="speech-name">李拥军</span>
                            <div class="speech-card-info">
                                <p>冶金工业经济发展研究中心</p>
                                <p>党委书记、主任</p>
                            </div>
                        </div>
                    </div>
                    <div class="speech-card">
                        <div class="speech-card-img-wrapper">
                            <img :src="require('../../assets/images/2026/avatar_jia.png')" alt="贾银松" class="speech-photo">
                            <span class="speech-name">贾银松</span>
                            <div class="speech-card-info">
                                <p>原国家工信部原材料司巡视员、</p>
                                <p>全联冶金商会秘书长</p>
                            </div>
                        </div>
                    </div>
                    <div class="speech-card">
                        <div class="speech-card-img-wrapper">
                            <img :src="require('../../assets/images/2026/avatar_song.png')" alt="宋雷" class="speech-photo">
                            <span class="speech-name">宋雷</span>
                            <div class="speech-card-info">
                                <p>唐宋大数据产业股份有限公司</p>
                                <p>董事长</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="speech-cards speech-cards-left" style="margin-top: 30px;">
                    <div class="speech-card">
                        <div class="speech-card-img-wrapper">
                            <img :src="require('../../assets/images/2026/avatar_li_lt.png')" alt="李林涛" class="speech-photo">
                            <span class="speech-name">李林涛</span>
                            <div class="speech-card-info">
                                <p>山东冠洲股份有限公司</p>
                                <p>营销部部长</p>
                            </div>
                        </div>
                    </div>
                    <div class="speech-card">
                        <div class="speech-card-img-wrapper">
                            <img :src="require('../../assets/images/2026/avatar_li_fh.png')" alt="李峰辉" class="speech-photo">
                            <span class="speech-name">李峰辉</span>
                            <div class="speech-card-info">
                                <p>河钢集团供应链管理有限公司总经理</p>
                                <p>大河汇鑫董事</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="image-section">
            <div class="image-content">
                <div class="image-title">
                    <img :src="require('../../assets/images/2026/title_sign.png')" alt="会议签约" class="image-title-img">
                </div>
                <div class="image-wrapper">
                    <img :src="require('../../assets/images/2026/img_sign.png')" alt="签约仪式" class="section-image">
                </div>
            </div>
        </div>
        <div class="interview-section">
            <div class="interview-content">
                <div class="interview-title">
                    <img :src="require('../../assets/images/2026/title_interview.png')" alt="高端访谈" class="interview-title-img">
                </div>
                <div class="interview-image-wrapper">
                    <img :src="require('../../assets/images/2026/img_interview.png')" alt="高端访谈" class="interview-main-image">
                </div>
                <div class="interview-panel">
                    <div class="interview-host-box">
                        <div class="host-label">主持人</div>
                        <div class="host-info">
                            <div class="host-name">郭黎娟</div>
                            <div class="host-title">中国煤炭运销协会炼焦煤专委会秘书长</div>
                        </div>
                    </div>
                    <div class="interview-guests-box">
                        <div class="guest-label">访谈嘉宾</div>
                        <div class="guest-cards">
                            <div class="guest-card">
                                <div class="guest-name">宋雷</div>
                                <div class="guest-title">唐宋大数据董事长</div>
                            </div>
                            <div class="guest-card">
                                <div class="guest-name">阎宗文</div>
                                <div class="guest-title">宝钢原料采购中心专项总经理</div>
                            </div>
                            <div class="guest-card">
                                <div class="guest-name">陈永会</div>
                                <div class="guest-title">旭阳集团集团焦炭销售常务副总</div>
                            </div>
                            <div class="guest-card">
                                <div class="guest-name">戴召乾</div>
                                <div class="guest-title">永锋集团市场管理部部长</div>
                            </div>
                            <div class="guest-card">
                                <div class="guest-name">林传华</div>
                                <div class="guest-title">杭钢外贸矿产事业一部总经理</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="interview-section">
            <div class="interview-content">
                <div class="interview-title">
                    <img :src="require('../../assets/images/2026/title_market.png')" alt="钢材市场" class="interview-title-img">
                </div>
                <div class="interview-image-wrapper">
                    <img :src="require('../../assets/images/2026/img_market.png')" alt="钢材市场" class="interview-main-image">
                </div>
                <div class="interview-panel">
                    <div class="interview-host-box">
                        <div class="host-label">主持人</div>
                        <div class="host-info">
                            <div class="host-name">余小雯</div>
                            <div class="host-title">广东乐从钢铁世界期现研究主任</div>
                        </div>
                    </div>
                    <div class="interview-guests-box">
                        <div class="guest-label">访谈嘉宾</div>
                        <div class="guest-cards">
                            <div class="guest-card">
                                <div class="guest-name">宋雷</div>
                                <div class="guest-title">唐宋大数据董事长</div>
                            </div>
                            <div class="guest-card">
                                <div class="guest-name">王俊峰</div>
                                <div class="guest-title">安泰钢铁集团副总经理</div>
                            </div>
                            <div class="guest-card">
                                <div class="guest-name">张世伟</div>
                                <div class="guest-title">正大制管集团经营中心副总监</div>
                            </div>
                            <div class="guest-card">
                                <div class="guest-name">周国峰</div>
                                <div class="guest-title">钢钢好电子商务有限公司总经理</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="award-section">
            <div class="award-content">
                <div class="award-title">
                    <img :src="require('../../assets/images/2026/title_award.png')" alt="颁奖典礼" class="award-title-img">
                </div>
                <div class="award-tabs">
                    <button 
                        v-for="(tab, index) in awardTabs" 
                        :key="index"
                        :class="['award-tab', { 'active': currentTab === index }]"
                        @click="currentTab = index"
                    >
                        {{ tab.name }}
                    </button>
                </div>
                <div class="award-image-wrapper">
                    <img :src="awardTabs[currentTab].image" :alt="awardTabs[currentTab].name" class="award-image">
                </div>
                <div class="award-text">
                    <span v-for="(item, index) in awardTabs[currentTab].text" :key="index" class="award-item">{{ item }}</span>
                </div>
            </div>
        </div>
        <div class="sponsor-section">
            <div class="sponsor-content">
                <div class="sponsor-title">
                    <img :src="require('../../assets/images/2026/title_sponsor.png')" alt="会议赞助" class="sponsor-title-img">
                </div>
                <div class="sponsor-item">
                    <div class="sponsor-subtitle">主办单位</div>
                    <div class="sponsor-list">
                        <span class="sponsor-company">唐宋大数据产业股份有限公司</span>
                    </div>
                </div>
                <div class="sponsor-item">
                    <div class="sponsor-subtitle">承办单位</div>
                    <div class="sponsor-list">
                        <span class="sponsor-company">中国钢铁产业网</span>
                    </div>
                </div>
                <div class="sponsor-item">
                    <div class="sponsor-subtitle">联合主办单位</div>
                    <div class="sponsor-list">
                        <span class="sponsor-company">杭州杭钢对外经济贸易有限公司</span>
                        <span class="sponsor-company">河钢集团供应链管理有限公司</span>
                        <span class="sponsor-company">山东冠洲股份有限公司</span>
                        <span class="sponsor-company">正大制管集团</span>
                    </div>
                </div>
                <div class="sponsor-item">
                    <div class="sponsor-subtitle">支持单位</div>
                    <div class="sponsor-list">
                        <span class="sponsor-company">中国钢铁工业协会</span>
                        <span class="sponsor-company">全联冶金商会</span>
                        <span class="sponsor-company">中国煤炭运销协会</span>
                        <span class="sponsor-company">唐山市工业和信息化局</span>
                    </div>
                </div>
                <div class="sponsor-item">
                    <div class="sponsor-subtitle">赞助单位</div>
                    <div class="sponsor-list">
                        <span class="sponsor-company">秦皇岛宏兴钢铁集团有限公司</span>
                        <span class="sponsor-company">秦皇岛佰工钢铁有限公司</span>
                        <span class="sponsor-company">天津钢铁集团有限公司</span>
                        <span class="sponsor-company">河北东海特钢集团有限公司</span>
                        <span class="sponsor-company">厦门建发金属有限公司</span>
                        <span class="sponsor-company">河北安丰钢铁集团有限公司</span>
                        <span class="sponsor-company">天津友发钢管集团股份有限公司</span>
                        <span class="sponsor-company">天津荣程联合钢铁集团有限公司</span>
                        <span class="sponsor-company">山西建邦集团有限公司</span>
                        <span class="sponsor-company">山西晋南钢铁集团有限公司</span>
                        <span class="sponsor-company">河北津西钢铁集团股份有限公司</span>
                        <span class="sponsor-company">上海东亚期货有限公司</span>
                    </div>
                </div>
                <div class="sponsor-item">
                    <div class="sponsor-subtitle">特别赞助单位</div>
                    <div class="sponsor-list">
                        <span class="sponsor-company">城建珑湖丽宫</span>
                    </div>
                </div>
                <div class="sponsor-item">
                    <div class="sponsor-subtitle">特别鸣谢单位</div>
                    <div class="sponsor-list">
                        <span class="sponsor-company">宝山钢铁股份有限公司</span>
                        <span class="sponsor-company">旭阳集团</span>
                        <span class="sponsor-company">山东钢铁集团永锋临港有限公司</span>
                        <span class="sponsor-company">广东乐从钢铁世界有限公司</span>
                        <span class="sponsor-company">山西安泰控股集团有限公司</span>
                        <span class="sponsor-company">物产中大期货有限公司</span>
                        <span class="sponsor-company">物产中大资本管理有限公司</span>
                        <span class="sponsor-company">钢钢好电子商务有限公司</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'activitiesDetail2026bj',
    data() {
        return {
            currentTab: 0,
            awardTabs: [
                {
                    name: '十佳钢铁生产企业',
                    image: require('../../assets/images/2026/img_top10_production.png'),
                    text: [
                        '天津钢铁集团有限公司',
                        '石横特钢集团有限公司',
                        '山东钢铁集团永锋临港有限公司',
                        '磐石建龙钢铁有限公司',
                        '江苏省镔鑫钢铁集团有限公司',
                        '秦皇岛宏兴钢铁集团有限公司',
                        '山西建邦集团有限公司',
                        '河北津西钢铁集团股份有限公司',
                        '河北安丰钢铁集团有限公司',
                        '唐山东华钢铁企业集团有限公司'
                    ]
                },
                {
                    name: '十佳钢铁综合贸易企业',
                    image: require('../../assets/images/2026/img_top10_trade.png'),
                    text: [
                        '厦门建发金属有限公司',
                        '苏美达国际技术贸易有限公司',
                        '杭州杭钢对外经济贸易有限公司',
                        '河北港济实业有限公司',
                        '唐山凯荣国际贸易有限公司',
                        '河钢集团供应链管理有限公司',
                        '浙商中拓集团股份有限公司',
                        '河北物流集团金属材料有限公司',
                        '浙江物产道富有限公司',
                        '青岛九州物资有限公司'
                    ]
                },
                {
                    name: '百强企业',
                    image: require('../../assets/images/2026/img_top100.png'),
                    text: [
                        '新绛天地和金属制品有限公司',
                        '山西中通交通设施有限公司',
                        '防城港天地和金属制品有限公司',
                        '唐山宏腾贸易有限公司',
                        '邯郸正大制管集团股份有限公司',
                        '山东冠洲股份有限公司',
                        '天津友发钢管集团股份有限公司',
                        '天津市利达钢管集团有限公司',
                        '河北盛泰制管有限公司',
                        '天津市群胜达钢管有限公司',
                        '内蒙古中卷钢板有限公司',
                        '天津源泰德润钢管制造集团有限公司',
                        '山东环富国际贸易有限公司',
                        '广东宝盛钢铁贸易有限公司',
                        '辽宁海力特种石油装备有限公司',
                        '唐山金红英物流有限公司',
                        '天津昕田管道科技有限公司',
                        '庆云华兴钢架工程有限公司',
                        '天津汇来国际贸易有限公司',
                        '南京友发物资有限公司',
                        '广东飞剪金属制品有限公司',
                        '永安期货股份有限公司',
                        '北京盛裕成科技发展有限公司',
                        '唐山集荣贸易有限公司',
                        '唐山象屿正丰国际物流有限公司',
                        '扬州鸿蓝钢铁加工有限公司',
                        '金鼎钢铁集团煤焦化有限公司',
                        '南京钢首金属实业有限公司',
                        '佛山市三水振鸿钢制品有限公司',
                        '山东新石特钢铁有限公司',
                        '青县冀通钢材销售有限公司',
                        '河南大道至简钢铁有限公司',
                        '天津市宝来工贸有限公司'
                    ]
                },
                {
                    name: '星级企业',
                    image: require('../../assets/images/2026/img_star.png'),
                    text: [
                        '天津汇来国际贸易有限公司五星',
                        '防城港天地和金属制品有限公司五星',
                        '辽宁海力特种石油装备有限公司五星',
                        '厦门建发金属有限公司五星',
                        '邯郸正大制管集团股份有限公司五星',
                        '杭州杭钢对外经济贸易有限公司五星',
                        '河北港济实业有限公司五星',
                        '浙商中拓集团股份有限公司五星',
                        '上海东亚期货有限公司五星',
                        '唐山东华钢铁企业集团有限公司六星',
                        '河南大道至简钢铁有限公司六星',
                        '唐山凯荣国际贸易有限公司六星',
                        '新绛天地和金属制品有限公司七星',
                        '天津友发钢管集团股份有限公司九星',
                        '河北安丰钢铁集团有限公司九星',
                        '河北盛泰制管有限公司九星',
                        '永安期货股份有限公司十星',
                        '秦皇岛宏兴钢铁集团有限公司十一星',
                        '苏美达国际技术贸易有限公司十一星',
                        '庆云华兴钢架工程有限公司十一星',
                        '唐山象屿正丰国际物流有限公司十二星'
                    ]
                }
            ]
        }
    },
    mounted() {}
}
</script>
<style scoped>
.annual-meeting-page {
    width: 100%;
    min-height: 100vh;
}
.top-banner {
    width: 100%;
}
.banner-img {
    width: 100%;
    display: block;
}
.intro-section {
    width: 100%;
    padding: 60px 0;
}
.intro-content {
    width: 1200px;
    margin: 0 auto;
}
.intro-panel {
    background: #fff;
    border-radius: 8px;
    padding: 30px;
    display: flex;
    box-shadow: 0 4px 20px rgba(0,0,0,0.1);
}
.intro-left {
    flex: 1;
    padding-right: 30px;
}
.intro-img {
    width: 100%;
    display: block;
    border-radius: 4px;
}
.intro-right {
    flex: 1;
    display: flex;
    flex-direction: column;
}
.intro-title-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.intro-year {
    font-size: 28px;
    font-weight: bold;
    color: #d93636;
    line-height: 64px;
}
.intro-divider {
    font-size: 40px;
    font-weight: 100;
    color: #d93636;
    margin: 0 15px;
    line-height: 64px;
}
.intro-title-wrapper {
    display: flex;
    flex-direction: column;
}
.intro-title {
    font-size: 20px;
    font-weight: bold;
    color: #d93636;
    line-height: 32px;
}
.intro-text {
    margin-top: 20px;
    font-size: 14px;
    line-height: 28px;
    color: #666;
    text-indent: 2em;
}
.speech-section {
    width: 100%;
    padding: 60px 0;
    background: #fff;
}
.speech-content {
    width: 1200px;
    margin: 0 auto;
}
.speech-title {
    text-align: center;
    margin-bottom: 40px;
}
.speech-title-img {
    display: inline-block;
    max-width: 100%;
    height: auto;
}
.speech-cards {
    display: flex;
    justify-content: space-between;
}
.speech-cards-left {
    justify-content: flex-start;
    gap: 29px;
}
.speech-card {
    width: calc(33.33% - 20px);
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0,0,0,0.1);
}
.speech-card-img-wrapper {
    position: relative;
    width: 100%;
    height: 280px;
    overflow: hidden;
}
.speech-photo {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    margin: 0;
    padding: 0;
    border: none;
}
.speech-name {
    position: absolute;
    top: 15px;
    left: 15px;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    background: rgba(0,0,0,0.5);
    padding: 5px 15px;
    border-radius: 4px;
}
.speech-card-info {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    padding: 15px;
}
.speech-card-info p {
    margin: 0;
    font-size: 14px;
    color: #666;
    line-height: 24px;
    text-align: left;
}
.image-section {
    width: 100%;
    padding: 60px 0;
    background: #fff;
}
.image-content {
    width: 1200px;
    margin: 0 auto;
}
.image-title {
    text-align: center;
    margin-bottom: 40px;
}
.image-title-img {
    display: inline-block;
    max-width: 100%;
    height: auto;
}
.image-wrapper {
    width: 100%;
}
.section-image {
    width: 100%;
    display: block;
}
.interview-section {
    width: 100%;
    padding: 60px 0;
    background: linear-gradient(180deg, #fff 0%, #f8f8f8 100%);
}
.interview-content {
    width: 1200px;
    margin: 0 auto;
}
.interview-title {
    text-align: center;
    margin-bottom: 40px;
}
.interview-title-img {
    display: inline-block;
    max-width: 100%;
    height: auto;
}
.interview-image-wrapper {
    width: 100%;
    margin-bottom: 40px;
}
.interview-main-image {
    width: 100%;
    display: block;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.1);
}
.interview-panel {
    background: #fff;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 2px 15px rgba(0,0,0,0.05);
}
.interview-host-box {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    padding: 15px 20px;
    background: linear-gradient(135deg, #c00 0%, #a00 100%);
    border-radius: 8px;
}
.host-label {
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    padding: 5px 15px;
    background: rgba(255,255,255,0.2);
    border-radius: 4px;
    margin-right: 20px;
}
.host-info {
    flex: 1;
}
.host-name {
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 5px;
}
.host-title {
    color: rgba(255,255,255,0.85);
    font-size: 14px;
}
.interview-guests-box {
    margin-top: 20px;
}
.guest-label {
    font-size: 16px;
    font-weight: bold;
    color: #c00;
    margin-bottom: 15px;
    padding-left: 10px;
    border-left: 3px solid #c00;
}
.guest-cards {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
}
.guest-card {
    flex: 1;
    min-width: 200px;
    max-width: calc(50% - 8px);
    padding: 15px 20px;
    background: #f5f5f5;
    border-radius: 8px;
    border-left: 3px solid #c00;
    transition: all 0.3s ease;
}
.guest-card:hover {
    background: #fff5f5;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(200,0,0,0.1);
}
.guest-name {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 8px;
}
.guest-title {
    font-size: 13px;
    color: #666;
}
.award-section {
    width: 100%;
    padding: 60px 0;
    background: #fff;
}
.award-content {
    width: 1200px;
    margin: 0 auto;
}
.award-title {
    text-align: center;
    margin-bottom: 40px;
}
.award-title-img {
    display: inline-block;
    max-width: 100%;
    height: auto;
}
.award-tabs {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 40px;
}
.award-tab {
    padding: 12px 30px;
    border: none;
    border-radius: 25px;
    background: #e8e8e8;
    color: #333;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
}
.award-tab.active {
    background: #337ab7;
    color: #fff;
}
.award-tab:hover {
    background: #337ab7;
    color: #fff;
}
.award-image-wrapper {
    width: 100%;
    margin-bottom: 30px;
}
.award-image {
    width: 100%;
    display: block;
}
.award-text {
    padding: 20px;
    background: #fff;
}
.award-item {
    display: inline-block;
    font-size: 14px;
    color: #337ab7;
    line-height: 30px;
    margin-right: 30px;
    margin-bottom: 10px;
}
.sponsor-section {
    width: 100%;
    padding: 60px 0;
    background: #fff;
}
.sponsor-content {
    width: 1200px;
    margin: 0 auto;
}
.sponsor-title {
    text-align: center;
    margin-bottom: 40px;
}
.sponsor-title-img {
    display: inline-block;
    max-width: 100%;
    height: auto;
}
.sponsor-item {
    margin-bottom: 30px;
}
.sponsor-subtitle {
    text-align: center;
    font-size: 18px;
    color: #c00;
    font-weight: bold;
    margin-bottom: 20px;
}
.sponsor-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
}
.sponsor-company {
    display: inline-block;
    width: 300px;
    padding: 8px 20px;
    background: #c00;
    color: #fff;
    border-radius: 20px;
    font-size: 14px;
    text-align: center;
}
</style>